import produce from 'immer';
import * as _ from 'lodash';
import React, {useState} from 'react';
import Measure from 'react-measure';

import {
  DragHandle,
  DragDropProvider,
} from '@wandb/common/containers/DragDropContainer';
import {LegacyWBIcon} from '@wandb/common/components/elements/LegacyWBIcon';

import {IdObj, PanelBankSectionConfig, PANEL_BANK_PADDING} from './panelbank';
import {PanelBankGridSection} from './PanelBankGridSection';
import {PanelBankFlowSection} from './PanelBankFlowSection';
import './PanelBank.less';
import './PanelBankEditablePanel.less';
import {getNewGridItemLayout} from './panelbankGrid';

interface PBSectionProps {
  mode: 'grid' | 'flow';
  config: PanelBankSectionConfig;
  updateConfig2: (
    fn: (config: PanelBankSectionConfig) => PanelBankSectionConfig
  ) => void;
  renderPanel: (panelRef: IdObj) => React.ReactNode;
}

export const PBSection: React.FC<PBSectionProps> = props => {
  const {config, updateConfig2} = props;
  const [panelBankWidth, setPanelBankWidth] = useState(0);
  const PanelBankSectionComponent =
    props.mode === 'grid' ? PanelBankGridSection : PanelBankFlowSection;
  return (
    <DragDropProvider>
      <div className="panel-bank">
        <Measure
          bounds
          onResize={contentRect => {
            setPanelBankWidth(
              contentRect.bounds
                ? contentRect.bounds.width - PANEL_BANK_PADDING * 2
                : 0
            );
          }}>
          {({measureRef}) => (
            <div className="panel-bank__sections" ref={measureRef}>
              <div className="panel-bank__section">
                <PanelBankSectionComponent
                  panelBankWidth={panelBankWidth}
                  panelBankSectionConfigRef={config}
                  updateConfig={updateConfig2}
                  activePanelRefs={config.panels}
                  inactivePanelRefs={[]}
                  renderPanel={panelRef => (
                    <div
                      style={{
                        backgroundColor: '#fff',
                        width: '100%',
                        height: '100%',
                      }}
                      className="editable-panel">
                      <DragHandle
                        key={`draghandle-${panelRef.id}`}
                        className="draggable-handle"
                        partRef={panelRef}>
                        <LegacyWBIcon title="" name="handle" />
                      </DragHandle>
                      {props.renderPanel(panelRef)}
                    </div>
                  )}
                  movePanelBetweenSections={() => {
                    console.log('MOVE BETWEEN SECTIONS');
                  }}
                />
              </div>
            </div>
          )}
        </Measure>
      </div>
    </DragDropProvider>
  );
};

export const getSectionConfig = (
  panelIds: string[],
  currentConfig: PanelBankSectionConfig | undefined
): PanelBankSectionConfig => {
  const gridConfig: PanelBankSectionConfig = currentConfig ?? {
    id: 'grid0',
    name: 'Section 0',
    panels: [],
    isOpen: true,
    flowConfig: {
      snapToColumns: true,
      columnsPerPage: 3,
      rowsPerPage: 2,
      gutterWidth: 10,
      boxWidth: 256,
      boxHeight: 256,
    },
    type: 'grid' as const,
    sorted: 0,
  };
  return produce(gridConfig, draft => {
    _.forEach(panelIds, name => {
      // Very bad! We use the variable name as the ID!
      if (gridConfig.panels.findIndex(p => p.id === name) !== -1) {
        return;
      }
      draft.panels.push({
        id: name,
        layout: getNewGridItemLayout(
          gridConfig.panels.map(p => p.layout),
          false
        ),
      });
    });
  });
};
